import React from 'react';
import VoxelDialog from '../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActionCancel from '../../../components/voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import { LicenseWarningBag } from './useLicenseIncreaseWarning';

export interface LicenseIncreaseWarningDialogProps {
  licenseWarningBag: LicenseWarningBag;
}

export const LicenseIncreaseWarningDialog: React.FC<LicenseIncreaseWarningDialogProps> = ({
  licenseWarningBag,
}) => {
  if (!licenseWarningBag.showWarning) return null;
  return (
    <VoxelDialog onClose={licenseWarningBag.handleCancel} open title="Adding license">
      <VoxelDialogContent>
        This will add an additional license{' '}
        {!licenseWarningBag.team.customAppTier && 'for $49/month'} to your team's subscription plan.
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={licenseWarningBag.handleCancel} />
        <VoxelDialogActionSubmit onClick={licenseWarningBag.handleProceed} title="Proceed" />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default LicenseIncreaseWarningDialog;
